import {memo} from 'react'
import {NavLink as RouterLink, type NavLinkProps} from 'react-router'
import {NavItem, type NavItemProps} from './NavItem'

const StyledNavLink = memo((props: NavLinkProps) => (
  <RouterLink {...props} className={({isActive}) => `${props.className} ${isActive ? 'Mui-selected' : ''}`}/>
))

interface Props extends NavItemProps {
  to: string
}

export const NavLink = memo(({to, ...rest}: Props) => {
  return <NavItem item={{component: StyledNavLink, to}} {...rest} />
})
